var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7290_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16V32C0 33.0609 0.421427 34.0783 1.17157 34.8284C1.92172 35.5786 2.93913 36 4 36H36C37.0609 36 38.0783 35.5786 38.8284 34.8284C39.5786 34.0783 40 33.0609 40 32V16L20 24L0 16Z",
    fill: "#996CFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.93913 4 1.92172 4.42143 1.17157 5.17157C0.421427 5.92172 0 6.93913 0 8L0 12L20 20L40 12V8C40 6.93913 39.5786 5.92172 38.8284 5.17157C38.0783 4.42143 37.0609 4 36 4H4Z",
    fill: "#996CFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7290_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.033f74ab94717add8b3583ebfbb322f3.svg";
export { ForwardRef as ReactComponent };